/**
 * Entidad/disciplina de certificación (espejo del enum backend
 * App\Enums\Partner\PartnerProcessEntity). Se usa como `entity_type`.
 */
export const CERT_ENTITY = Object.freeze({
  CIVIL: 1,
  MECHANICAL: 2,
  ELECTRICAL: 3,
})
